const globalReducer = (draft, action) => {
    switch (action.type) {
        case "setIsLoading":
            draft.isLoading = action.value;
            return
        case "setTabValue":
            draft.tabValue = action.value;
            return
        case "setShowTabs":
            draft.showTabs = action.value;
            return
        case "setSideMenuItems":
            draft.sideMenuItems = action.value;
            return
        case "setSchools":
            draft.schools = action.value;
            return
        case "setClassrooms":
            draft.classrooms = action.data;
            return
        case "setIsOpenSnackbar":
            draft.isOpenSnackbar = action.value;
            return
        case "setSnackbarMsg":
            draft.snackbarMsg = action.value;
            return
        default:
            return
    }
};

export default globalReducer;